export { default } from './HotelCard';
